//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV>
  <div class='content-wrapper'>
    <div class="text">
      404: Страница не найдена<br>
      <br>
      <router-link to="/" class="link">
        <Button type="primary" size="large" class="button-primary" style="width:250px">Перейти на главную</Button>
      </router-link>
    </div>
  </div>
  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
export default {
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper {
  width: 100%;
  height: 100%;
  background: #D9E0E7;
}
.text {
  width: 100%;
  padding: 100px 20px 0 20px;
  background: #D9E0E7;
  color: #2c3e50;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 40px;
  text-align: center;
}
.link {
  color: #778 !important;
  text-decoration: none !important;
  cursor: pointer !important;
}
.link:hover {
  color: #808aa0 !important;
  text-decoration: none !important;
}
.button-primary{
  margin: 20px 4.5% 20px 4.5%;
  /*background: #6770a6;*/
  border-radius: 15px;
  background: #6070dd;
  font-size: 16px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// 404PageNotFound.vue?05e58561